import { createReducer } from "@reduxjs/toolkit";
import { GetDeliveryHistory, GetHistoryItem } from "./deliveryHistory";

const handleAsyncActions = (builder, action, stateKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[stateKey] = true; 
            state[stateKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[stateKey] = false; 
            state[stateKey] = action.payload; 
            if(stateKey === 'DeliveryHistory'){
                localStorage.setItem('PAGEData', `${action.payload[0]?.status}`)
                // sessionStorage.setItem('deliveryHistory', JSON.stringify(action.payload))
            }
            if(stateKey === 'DeliveryItems') {               
                sessionStorage.setItem('Items', JSON.stringify(action.payload))
            }
            state.error[errorKey] = null; 
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[stateKey] = false; 
            state.error[errorKey] = action.payload; 
        });
};

const initialState = {
    DeliveryHistory: null,
    DeliveryItems:null,

    loading: {
        DeliveryHistory: false,
        DeliveryItems:false,

    },

    error: {
        DeliveryHistoryError: null,
        DeliveryItemsError:null,
    },
};

export const DeliveryHistoryReducer = createReducer(initialState, (builder) => {
    handleAsyncActions(builder, GetDeliveryHistory, "DeliveryHistory", "DeliveryHistoryError");
    handleAsyncActions(builder, GetHistoryItem, "DeliveryItems", "DeliveryItemsError");
    
});

export default DeliveryHistoryReducer;
